import { RegisterInput, RegisterUserInput } from '../types';
import { client } from './axiosClient';

export const registerSetupCheck = async (data: RegisterInput) => {
  const res = await client.post('/register', data);
  return res.data;
};
export const registerSeller = async (data: RegisterUserInput) => {
  const res = await client.post('/user-register', data);
  return res.data;
};
